import { Component, OnInit } from '@angular/core';
import { CommonData } from '../../models';
import { DataService } from '../../services';

@Component({
  selector: 'app-work-process',
  templateUrl: './work-process.component.html',
  styleUrls: ['./work-process.component.scss']
})
export class WorkProcessComponent implements OnInit {
  workprocess: CommonData[] = [];
  constructor( private dataService: DataService ) { }

  ngOnInit(): void {
    this.workprocess = this.dataService.getLocalWorkProcess();
  }
}
